export default __webpack_public_path__ + "static/media/feedback-blue.754d67a6.svg";